<template>
  <div>
    <speed-dial
      :type="fabType"
      :items="fabItems"
    />
    <v-row>
      <v-tabs :class="isProfileTab ? 'pl-3' : this.$route.name === 'operator-groups' ? 'pl-3' : ''" height="61px" :style="[$vuetify.theme.dark ? { 'border-bottom': '1px solid #424242' } : { 'border-bottom': '1px solid #dedede' }]">
        <span class="NSoft-Assets-Devices mt-5 ml-6">
          <span class="text-uppercase">{{ space_name }}</span>
          <span class="capitalize Text-Style-4"> / {{$t('profiles.title')}}</span>
        </span>
      </v-tabs>
    </v-row>
    <v-row>
      <v-col class="px-0 py-0" :style="[$vuetify.theme.dark ? { 'border-bottom': '1px solid #424242' } : { 'border-bottom': '1px solid #dedede' }]">
        <v-tabs class="tab-color" :class="isProfileTab ? 'pl-3' : this.$route.name === 'operator-groups' ? 'pl-3' : ''" :value="currentTab">
          <v-tab active-class="selected-tab" to="/administrators">{{$t('profiles.tabs.adminTab')}}</v-tab>
          <v-tab active-class="selected-tab" to="/operators">{{$t('profiles.tabs.operatorsTab')}}</v-tab>
          <v-tab active-class="selected-tab" to="/operator-groups">{{$t('profiles.tabs.operatorsGroupTab')}}</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-divider class="mx-1" style="margin-top: -1px" />
    <router-view/>
  </div>
</template>
<script>
import SpeedDial from "../components/SpeedDial";
import {mdiSend , mdiAccountPlus, mdiAccountGroup} from "@mdi/js";
import { mapGetters } from "vuex";


export default {
  computed: {
    ...mapGetters({
      gatSpaceName: 'global/getSpace',
      "space_name":"accounts/spaceName"
    }),
    fabType() {
      const seg = this.$route.path.split('/')[1];
      if (seg === 'operators') return '/operators';
      if (seg === 'operator-groups') return '/operator-groups';
      return '/administrators';
    },

    // items s .action koji popunjava preostali dio puta
    fabItems() {
    const seg = this.$route.path.split('/')[1];

    if (seg === 'administrators' || !seg) {
      return [
        { tooltip: 'Invite Admin', icon: mdiSend, action: 'inviteUser' },
      ];
    }

  if (seg === 'operators') {
      return [
        {
          tooltip: 'Create Operator',
          icon: mdiAccountPlus,
          // pass a full route location object instead of a string
          action: {
            name: 'addOperator',
            params: { action: 'addOperator', progress: 1 }
          }
        },
      ];
    }


  if (seg === 'operator-groups') {
    return [
      { tooltip: 'Add Operator Group', icon: mdiAccountGroup, action: 'add' },
    ];
  }

  return [];
},
    isProfileTab(){
      return ['operators', 'operator-groups', 'viewOperator', 'addOperator', 'addOperatorGroup', 'viewOperatorGroup', 'editOperator', 'editOperatorGroup', 'resetOperatorCredentials'].includes(this.routeName)
      },
    routeName() {
     return this.$route.name;
      },
     currentTab() {
    // Get the first part of the path, e.g., 'administrators', 'operators', etc.
    const path = this.$route.path.split('/')[1];
    switch (path) {
      case 'operators':
        return 1; // Index of the operators tab
      case 'operator-groups':
        return 2; // Index of the operator groups tab
      case 'administrators':
      default:
        return 0; // Default to administrators tab
    }
  },
  },
  
  name: "Profiles",
  components: {
    "speed-dial": SpeedDial,

  },
  methods: {
    onItemClick(item) {
      if (typeof item.action === 'object') {
        // full route location -> push directly
        this.$router.push(item.action);
      } else {
        // legacy string action — keep your old behavior here if needed
        // example:
        this.$router.push(`${this.type}/${item.action}`);
      }
    }
  },
  
  data: () => ({
    tab: null,
 
  }),
};
</script>
<style lang="scss" scoped>

.device-icon {
  padding: 20px;
  background-color: var(--v-lightGrey-base);
  border-radius: 4px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fab-button {
  margin-right: 64px;
}

.location-card {
  transition: all 0.1s ease !important;
}

.location-card:hover {
  background-color: var(-v--greyAlert-base, 0.3) !important;
}

.location-info {
  margin-left: 16px;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column !important;
}

.v-card__title {
  display: flex;
  flex-direction: row;
}

.circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 8px;
}

.selected-tab {
  color: var(--v-textColor-base);
}

.NSoft-Assets-Devices {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  color: var(--v-secondaryText-base);
}

.NSoft-Assets-Devices .Text-Style-4 {
  color: var(--v-textColor-base) !important;
}

::v-deep {
  .v-tab {
    letter-spacing: normal;
  }
}

</style>
